export default __webpack_public_path__ + "static/media/marketplacev3.b57a29df.jpg";